<template>
    <b-container>
        <b-row class="justify-content-center">
            <b-col cols="12" class="text-left">
                <h2 class="text-center">Complimenti</h2>
                <p class="text-center">La registrazione &egrave; andata a buon fine. Di seguito un riepilogo dei dati inseriti; se sono corretti, clicca sul pulsante '<strong>SALVA</strong>' per terminare la procedura.<br /><br />Ti ricordiamo che l'iscrizione deve ancora essere approvata dal nostro Staff e riceverai una notifica via e-mail non appena verr&agrave; convalidata.</p>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <b-list-group>
                    <b-list-group-item>
                        <div class="small text-primary">Nome società</div>
                        <div class="text-uppercase">
                            {{society.name}}
                        </div>
                    </b-list-group-item>

                    <b-list-group-item>
                        <div class="small text-primary">Email società</div>
                        <div class="text-uppercase">
                            {{society.email}}
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="small text-primary">Telefono società</div>
                        <div class="text-uppercase">
                            {{society.phone}}
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <b-list-group>
                    <b-list-group-item>
                        <div class="small text-primary">Nome referente</div>
                        <div class="text-uppercase">
                            {{referente.name}} {{referente.surname}}
                        </div>
                    </b-list-group-item>

                    <b-list-group-item>
                        <div class="small text-primary">Email referente</div>
                        <div class="text-uppercase">
                            {{referente.email}}
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="small text-primary">Telefono referente</div>
                        <div class="text-uppercase">
                            {{referente.phone}}
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "RegisterWizardStepFive",
        props: {
            society: {
                type: Object,
                default: () => {
                }
            },
            referente: {
                type: Object,
                default: () => {
                }
            }
        },
    }
</script>

<style scoped>

</style>
